import React, { useEffect } from "react";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import { GeoMultiPolygon, GeoPolygon } from "@mapmycustomers/shared/types/shapes";
import { convertPolygonToBeOfLatLngLiterals } from "@mapmycustomers/shared/util/territory/convertLongLatGeoShapesToLatLngLiteral";

import { useMap } from "@app/component/map/FeaturedMap";
import anyColorToHex from "@app/util/colors/anyColorToHex";
import { AREA_REGION_UNITED_REGION } from "@app/util/map/consts";

// const formatSize = (size: number) => {
//   if (size < 1024) {
//     return `${size}b`;
//   } else if (size < 1024 * 1024) {
//     return `${Math.round(size / 1024)}k`;
//   } else {
//     return `${(size / (1024 * 1024)).toFixed(1)}M`;
//   }
// };

interface Props {
  color: AnyColor;
  opacity: number;
  polygon?: GeoMultiPolygon | GeoPolygon;
}

const CompoundRegion: React.FC<Props> = ({ color, opacity, polygon }) => {
  const { map } = useMap();

  useEffect(() => {
    if (!polygon) {
      return;
    }

    // const size2 = JSON.stringify(polygon.geometry).length;
    // console.log(
    //   "compound territory size2",
    //   formatSize(size1),
    //   formatSize(size2),
    //   `${Math.round((size2 / size1) * 100)}%`,
    //   "predicted after gzip=",
    //   formatSize(Math.round(size2 * 0.4)),
    //   `${Math.round(((0.4 * size2) / size1) * 100)}%`
    // );

    const polygons = (polygon.type === "Polygon" ? [polygon.coordinates] : polygon.coordinates).map(
      (polygon) =>
        new google.maps.Polygon({
          clickable: false,
          draggable: false,
          fillColor: anyColorToHex(color),
          fillOpacity: opacity,
          map,
          paths: convertPolygonToBeOfLatLngLiterals(polygon),
          strokeColor: anyColorToHex(color),
          strokeOpacity: 1,
          strokeWeight: 4,
          zIndex: AREA_REGION_UNITED_REGION,
        })
    );

    return () => {
      polygons.forEach((polygon) => polygon.setMap(null));
    };
  }, [color, map, opacity, polygon]);

  return null;
};

export default CompoundRegion;
